import { render, staticRenderFns } from "./SelectMechanism.vue?vue&type=template&id=a5121a9c&scoped=true"
import script from "./SelectMechanism.vue?vue&type=script&lang=ts"
export * from "./SelectMechanism.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5121a9c",
  null
  
)

export default component.exports